/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarTealSvg from './icon-avatar-teal.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarTealSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarTeal';

export const AvatarTealIcon = svgIconWrapper(SvgComponent);
